import React from 'react';
import _ from 'lodash';

import {
  useNavigate,
  useParams,
  useSearchParams
} from 'react-router-dom';
import {
  PermissionWall,
  activityTemplates,
  permissionUtil,
  routeDirectory
} from 'modules';

import * as ItemTab from './ItemTab/ItemTab';
import * as TemplateTab from './TemplateTab/TemplateTab';
import { TabBar } from 'iron-forge-react-modules';
import { Box, IconButton, Paper, styled } from '@mui/material';
import {
  ArrowBack as MuiArrowBack
} from '@mui/icons-material';
import useRouteLocation from 'modules/layer00/hooks/useRouteLocation';

const AppBar = styled('div')(({ theme }) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  background: "white",
  padding: '0 24px'
}));

const ArrowBack = styled(MuiArrowBack)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 34
}));

const ButtonBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1)
}));


export const InventoryActivity: React.FC = () => {
  const params = useParams<{ tabId: 'items' | 'templates'; }>();
  const [search] = useSearchParams();
  const storeId = search.get('storeId') ?? undefined;

  const navigate = useNavigate();
  const [hasPermission] = permissionUtil.usePermissions({ storeId, evaluationCriteria: 'all' });
  // getting route location
  const { isMatched: fromPartner } = useRouteLocation('partner');


  const handleSelectTab = React.useCallback(
    (tabId: string) => {
      if (tabId === 'items' || tabId === 'templates') {
        navigate(routeDirectory.admin.inventory.path(tabId));
      }
    },
    [navigate]
  );



  const tabs = React.useMemo(
    () => _.compact([
      hasPermission(['inventory_viewItemList']) ? {
        id: 'items',
        label: "Items"
      } : null,
      hasPermission(['inventory_viewListingManagementStrategyTemplateGroup']) ? {
        id: 'templates',
        label: "Templates"
      } : null
    ]),
    [hasPermission]
  );

  const inventoryActivityTabComponents = (
    <>
      <TabBar.FC
        tabId={params.tabId ?? ''}
        onSelectTab={handleSelectTab}
        tabs={tabs} />

      <Paper sx={{ padding: '10px' }}>
        {params.tabId === 'items' && (
          <PermissionWall.FC storeId={storeId} requiresPermissions={['inventory_viewItemList']}>
            <ItemTab.FC />
          </PermissionWall.FC>
        )}

        {params.tabId === 'templates' && (
          <PermissionWall.FC storeId={storeId} requiresPermissions={['inventory_viewListingManagementStrategyTemplateGroup']}>
            <TemplateTab.FC />
          </PermissionWall.FC>
        )}
      </Paper>
    </>
  );

  function handleClickBack() {
    navigate(-1);
  }

  const inventoryActivity = (
    fromPartner ? (
      <>
        <AppBar>
          <ButtonBox>
            <IconButton onClick={handleClickBack}>
              <ArrowBack />
            </IconButton>
          </ButtonBox>
        </AppBar>

        {inventoryActivityTabComponents}
      </>

    ) : <activityTemplates.AdminActivityTemplate.FC>{inventoryActivityTabComponents}</activityTemplates.AdminActivityTemplate.FC>
  );

  return inventoryActivity;
};
